import type { PropsWithChildren } from 'react'
import { Outlet } from '@tanstack/react-router'

// TODO: find a more straightforward way to do this
export const RawCenteredLayout = ({ children }: PropsWithChildren) => (
  <div className="flex h-screen w-full flex-col items-center justify-center gap-4 overflow-auto p-2">
    <main className="flex w-full flex-col items-center justify-center gap-4">{children}</main>
  </div>
)

export const CenteredLayout = () => (
  <RawCenteredLayout>
    <Outlet />
  </RawCenteredLayout>
)
